var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSlack = function SvgSlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#slack_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.06 15.17a2.518 2.518 0 0 1-2.52 2.52 2.518 2.518 0 0 1-2.52-2.52 2.518 2.518 0 0 1 2.52-2.52h2.52v2.52Zm1.26 0a2.518 2.518 0 0 1 2.52-2.52 2.518 2.518 0 0 1 2.52 2.52v6.3a2.518 2.518 0 0 1-2.52 2.52 2.518 2.518 0 0 1-2.52-2.52v-6.3Z",
    fill: "#E01E5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.84 5.05a2.518 2.518 0 0 1-2.52-2.52A2.518 2.518 0 0 1 8.84.01a2.518 2.518 0 0 1 2.52 2.52v2.52H8.84Zm0 1.28a2.518 2.518 0 0 1 2.52 2.52 2.518 2.518 0 0 1-2.52 2.52H2.52A2.518 2.518 0 0 1 0 8.85a2.518 2.518 0 0 1 2.52-2.52h6.32Z",
    fill: "#36C5F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.94 8.85a2.518 2.518 0 0 1 2.52-2.52 2.518 2.518 0 0 1 2.52 2.52 2.518 2.518 0 0 1-2.52 2.52h-2.52V8.85Zm-1.26 0a2.518 2.518 0 0 1-2.52 2.52 2.518 2.518 0 0 1-2.52-2.52V2.53A2.518 2.518 0 0 1 15.16.01a2.518 2.518 0 0 1 2.52 2.52v6.32Z",
    fill: "#2EB67D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.16 18.95a2.518 2.518 0 0 1 2.52 2.52 2.518 2.518 0 0 1-2.52 2.52 2.518 2.518 0 0 1-2.52-2.52v-2.52h2.52Zm0-1.26a2.518 2.518 0 0 1-2.52-2.52 2.518 2.518 0 0 1 2.52-2.52h6.32A2.518 2.518 0 0 1 24 15.17a2.518 2.518 0 0 1-2.52 2.52h-6.32Z",
    fill: "#ECB22E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "slack_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .01)",
    d: "M0 0h24v23.981H0z"
  })))));
};
export default SvgSlack;